import { TFunction } from 'i18next';

interface Item {
    id: number | string;
    label: (t: TFunction) => string;
}

export const USER_PROFILE_FIELDS: {
    ageRange: Array<Item>;
    educationLevel: Array<Item>;
    gender: Array<Item>;
    maritalStatus: Array<Item>;
    occupationStatus: Array<Item>;
    salaryRange: Array<Item>;
} = {
    ageRange: [
        {
            label: (t) => t('pdash:no_response'),
            id: 0,
        },
        {
            label: (t) => t('pdash:under_x', [18]),
            id: 1,
        },
        {
            label: (t) => t('pdash:between_x_and_x', [18, 24]),
            id: 2,
        },
        {
            label: (t) => t('pdash:between_x_and_x', [25, 29]),
            id: 3,
        },
        {
            label: (t) => t('pdash:between_x_and_x', [30, 39]),
            id: 4,
        },
        {
            label: (t) => t('pdash:between_x_and_x', [40, 49]),
            id: 5,
        },
        {
            label: (t) => t('pdash:above_x', [50]),
            id: 6,
        },
    ],
    educationLevel: [
        {
            label: (t) => t('pdash:no_response'),
            id: '0',
        },
        {
            label: (t) => t('pdash:high_school_diploma_or_equivalency_ged'),
            id: '1',
        },
        {
            label: (t) => t('pdash:associate_degree_junior_college'),
            id: '2',
        },
        {
            label: (t) => t('pdash:bachelors_degree'),
            id: '3',
        },
        {
            label: (t) => t('pdash:masters_degree'),
            id: '4',
        },
        {
            label: (t) => t('pdash:doctorate'),
            id: '5',
        },
        {
            label: (t) => t('pdash:professional_md_jd_dds_etc'),
            id: '6',
        },
        {
            label: (t) => t('pdash:less_than_high_school'),
            id: '7',
        },
    ],
    gender: [
        {
            label: (t) => t('pdash:no_response'),
            id: '0',
        },
        {
            label: (t) => t('pdash:male'),
            id: '1',
        },
        {
            label: (t) => t('pdash:female'),
            id: '2',
        },
    ],
    maritalStatus: [
        {
            label: (t) => t('pdash:no_response'),
            id: '0',
        },
        {
            label: (t) => t('pdash:single'),
            id: '1',
        },
        {
            label: (t) => t('pdash:married'),
            id: '2',
        },
        {
            label: (t) => t('pdash:divorced'),
            id: '3',
        },
        {
            label: (t) => t('pdash:widowed'),
            id: '4',
        },
        {
            label: (t) => t('pdash:separated'),
            id: '5',
        },
    ],
    occupationStatus: [
        {
            label: (t) => t('pdash:no_response'),
            id: '0',
        },
        {
            label: (t) => t('pdash:working_full_time'),
            id: '1',
        },
        {
            label: (t) => t('pdash:working_part_time'),
            id: '2',
        },
        {
            label: (t) => t('pdash:student'),
            id: '3',
        },
        {
            label: (t) => t('pdash:unemployed_or_laid_off'),
            id: '4',
        },
        {
            label: (t) => t('pdash:looking_for_work'),
            id: '5',
        },
        {
            label: (t) => t('pdash:keeping_house_or_raising_children_full_time'),
            id: '6',
        },
        {
            label: (t) => t('pdash:retired'),
            id: '7',
        },
    ],
    salaryRange: [
        {
            label: (t) => t('pdash:no_response'),
            id: '0',
        },
        {
            label: (t) => t('pdash:less_than_x_dollars', ['5,000']),
            id: '1',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['5,000', '11,999']),
            id: '2',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['12,000', '15,999']),
            id: '3',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['16,000', '24,999']),
            id: '4',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['25,000', '34,999']),
            id: '5',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['35,000', '49,999']),
            id: '6',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['50,000', '74,999']),
            id: '7',
        },
        {
            label: (t) => t('pdash:x_dollars_through_x_dollars', ['75,000', '99,999']),
            id: '8',
        },
        {
            label: (t) => t('pdash:x_dollars_and_greater', ['100,000']),
            id: '9',
        },
        {
            label: (t) => t('pdash:dont_know'),
            id: '10',
        },
    ],
};
